import styled from 'styled-components';
import { typography, colors, mediaQueries, size } from '@everlywell/leaves';

export const Wrapper = styled.div`
  max-width: 864px;
  margin: 0 auto;

  h2 {
    color: ${colors.teal4};
    ${typography.h3Text}
    font-size: 25px;
    font-weight: ${typography.weight.regular};
    margin-bottom: ${size.sm}px;
    :not(:first-child) {
      margin-top: ${size.xl1}px;
    }

    ${mediaQueries.forTabletVerticalUp} {
      ${typography.h2Text}
      :not(:first-child) {
        margin-top: ${size.xl3}px;
      }
    }
  }

  p {
    ${typography.bodyTextSmall};
    :not(:last-child) {
      margin-top: ${size.lg}px;
    }

    ${mediaQueries.forTabletVerticalUp} {
      ${typography.bodyText};
    }
  }
`;
